import React from "react";
import ReactPanZoom from 'react-image-pan-zoom-rotate';

const Preview = ({ uploadedfile,uploadedFileName }) => {
    return (
        <>
            <div style={{ position: "relative", margin: "20px" }}>
                {uploadedfile?.split(/[#?]/)[0].split('.').pop().trim().toLowerCase() == 'pdf' 
                 || uploadedFileName?.toLowerCase()?.endsWith(".pdf") ? 
                    <>
                        <iframe style={{ width: "100%", minHeight: "700px" }} src={uploadedfile}></iframe>
                    </> :
                    <ReactPanZoom image={uploadedfile} />
                }
            </div>
        </>

    )
}
export default Preview;